/**
 * Math classes and utilities mixed into PIXI namespace.
 *
 * @lends PIXI
 */
module.exports = {
    // These will be mixed to be made publicly available,
    // while this module is used internally in core
    // to avoid circular dependencies and cut down on
    // internal module requires.

    Point:              require('./Point'),
    ObservablePoint:    require('./ObservablePoint'),
    Matrix:             require('./Matrix'),
    GroupD8:            require('./GroupD8'),

    Circle:             require('./shapes/Circle'),
    Ellipse:            require('./shapes/Ellipse'),
    Polygon:            require('./shapes/Polygon'),
    Rectangle:          require('./shapes/Rectangle'),
    RoundedRectangle:   require('./shapes/RoundedRectangle')
};
